import AutocompleteTranslationField from './AutocompleteTranslationField';



export default AutocompleteTranslationField;
